module.exports = __webpack_public_path__ + "img/ch16_15_礼貌拒绝.4746dd08.jpg";